// PWA related sagas

import { take } from 'redux-saga/effects';

// Services
import { ErrorCategory, handleError } from '@services/errorService';

// Actions
import { PWAInstall } from '@actions/pwa';

export function* PWADownloadSaga(): Generator {
  try {
    let deferredPrompt: BeforeInstallPromptEvent | null = null;

    if (typeof window === 'object') {
      window.addEventListener('beforeinstallprompt', (e: Event) => {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault();
        // Stash the event so it can be triggered later.
        window.pwaPromt = e as BeforeInstallPromptEvent;
        deferredPrompt = e as BeforeInstallPromptEvent;
      });
    }
    while (true) {
      yield take(PWAInstall);

      try {
        if (deferredPrompt) {
          deferredPrompt.prompt();
          deferredPrompt = null;
        }
      } catch (e) {
        handleError(e, { category: ErrorCategory.API });
      }
    }
  } catch (e) {
    handleError(e, { category: ErrorCategory.API });
  }
}
